import React from 'react';

import { Checkbox, Col, Row, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import { ROLES } from 'src/constants';

import type { CheckboxValueType } from 'antd/es/checkbox/Group';

type RolesCheckboxPropsType = {
  onChange: (roles: string[]) => void;
  defaultValue?: Array<string>;
};

type RoleOption = {
  value: string;
  label: string;
  hint: string;
};

const ROLE_OPTIONS: RoleOption[] = [
  {
    value: ROLES.ROLE_NEIGHBOUR,
    label: 'Utilisateur',
    hint: "Accès à l'app mobile Roving",
  },
  {
    value: ROLES.ROLE_CUSTOMER,
    label: 'Gestionnaire Pilotage',
    hint: "Accès à l'app Pilotage (gestion d'un réseau pour un client)",
  },
  {
    value: ROLES.ROLE_INTERNAL,
    label: "Interne Ensembl'",
    hint: "Compte interne Ensembl' (employé, test)",
  },
  {
    value: ROLES.ROLE_ADMIN,
    label: 'Admin Control',
    hint: 'Accès complet au backoffice Control',
  },
];

const renderOption = ({ value, label, hint }: RoleOption) => (
  <Checkbox value={value} style={{ lineHeight: '32px' }}>
    {label}{' '}
    <Tooltip title={hint}>
      <InfoCircleOutlined style={{ color: '#9ca3af', marginLeft: 4 }} />
    </Tooltip>
  </Checkbox>
);

export const RolesCheckbox: React.FC<RolesCheckboxPropsType> = ({
  defaultValue,
  onChange,
}) => (
  <Checkbox.Group
    style={{ width: '100%' }}
    defaultValue={defaultValue}
    onChange={(roles: CheckboxValueType[]) => onChange(roles as string[])}
  >
    <Row gutter={[16, 8]}>
      {ROLE_OPTIONS.map(option => (
        <Col key={option.value} xs={24} sm={12}>
          {renderOption(option)}
        </Col>
      ))}
    </Row>
  </Checkbox.Group>
);
